import {flatten, uniq, get, chunk} from "lodash"
import Papa from "papaparse"

import teamService from "@irati/identity/services/teams"
import userService from "@irati/identity/services/users"
import {promiseSerialAll} from "@irati/utils/promise"
import {FormatMessage} from "@irati/utils/lang/types"

interface FailedUser {
  email: string
  message: string
}

const addUsersToTeamByCSV = (file: File, formatMessage: FormatMessage, tenantUuid: string, teamUuid: string) => {
  return new Promise((resolve) => {
    Papa.parse(file, {
      header: false,
      skipEmptyLines: true,
      complete: (results: any) => {
        const failedUsers: FailedUser[] = []
        let saved = false

        const chunks = chunk<string>(uniq(flatten(results.data)))

        const funcs = chunks.map((userChunk) => () => {
          return Promise.all(
            userChunk.map((email) => {
              return userService
                .getUserIdByEmail(email, tenantUuid)
                .then((user) => {
                  if (user) {
                    return teamService.addUserToTeam(teamUuid, user.uuid).then(() => {
                      saved = true
                    })
                  }
                  failedUsers.push({
                    email,
                    message: formatMessage({id: "platform.addBulkUsersToTeam.errors.userDoesNotExist"})
                  })
                })
                .catch((err) => {
                  const message = get(err, "response.data.message", formatMessage({id: "platform.addBulkUsersToTeam.errors.default"}))
                  failedUsers.push({
                    email,
                    message
                  })
                })
            })
          )
        })
        return promiseSerialAll(funcs).then(() => resolve({saved, failedUsers}))
      }
    })
  })
}

export default addUsersToTeamByCSV
